import { withDependencies } from '@wix/thunderbolt-ioc'
import { ILayoutDoneService, LayoutDoneServiceSymbol } from '@wix/thunderbolt-symbols'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import type { ChangedCompHandlers } from '../types'
import { name } from '../symbols'

export const ChangedCompsHandlers = withDependencies(
	[LayoutDoneServiceSymbol],
	(layoutDoneService: ILayoutDoneService): IModelUpdatesHandlersImplementor<ChangedCompHandlers> => {
		return {
			featureName: name,
			handlers: {
				columnOrderChanged: ({ compId }) => {
					layoutDoneService.addToChangedComponentsAndNotify(compId)
				},
				columnAlignmentChanged: ({ compId }) => {
					layoutDoneService.addToChangedComponentsAndNotify(compId)
				},
				shouldUpdateJsonFlagChanged: ({ shouldUpdateJsonFlag }) => {
					if (shouldUpdateJsonFlag) {
						layoutDoneService.tryNotifyComponentsChanged()
					}
				},
			},
		}
	}
)
